import React from 'react';

import styles from './DirectionIconStyles';

import DownArrowIcon from 'buyside/svgs/down_arrow.svg';
import RightArrowIcon from 'buyside/svgs/right_arrow.svg';
import UpArrowIcon from 'buyside/svgs/up_arrow.svg';

const DirectionIcon = ({ direction }) => {
  switch (direction) {
    case 'Up':
      return <UpArrowIcon className={styles.deltaUp} />;
    case 'Recently':
      return <UpArrowIcon className={styles.deltaUp} />;
    case 'Down':
      return <DownArrowIcon className={styles.deltaDown} />;
    case 'Holding':
      return <RightArrowIcon className={styles.deltaHolding} />;
  }
};

export default DirectionIcon;
